
const photos = ["https://i.imgur.com/qppgoLo.jpeg",
                "https://i.imgur.com/JBrrWxo.jpeg",
                "https://i.imgur.com/CZGkG6K.jpeg",
                "https://i.imgur.com/rMohY0f.jpeg",
                "https://i.imgur.com/puQssqG.jpeg",
                "https://i.imgur.com/nijLi9U.jpeg",
                "https://i.imgur.com/Cchi9w1.jpeg",
                "https://i.imgur.com/advmF48.jpeg",
                "https://i.imgur.com/3Q1hKty.jpeg",
                "https://i.imgur.com/t9v8bu3.jpeg",];


// add alts

export default photos;